import React, { useMemo } from "react";

export default (props) => {


  const users = props?.colDef?.cellEditorParams?.users;
  const userOptions = {}
  users.forEach((element) => {
    userOptions[element.id] = element.first_name+" "+element.last_name
  })


  const nameTranscod = (the_status) => {
    return userOptions[the_status]
  }

  const name = useMemo(() => nameTranscod(props.value), [props.value]);

  return (
    <div className="colour-renderer">
      {name}
    </div>
  );
};
